import { createContext } from 'react'

const AttemptContext = createContext({})

export default AttemptContext
